export enum CHANNEL {
  RTB = 'openRTB',
  PIC = 'pic',
  FRIDGE = 'fridge',
  HWACOM = 'hwacom'
}

export enum ADSORDER {
  SHOW_ORDER_EXTERNAL_TYPE = 'showOrderExternalType'
}

enum CAMPAIGN {
  BID_WEIGHT_SETTING = 'bid_weight_setting',
  ORDER_AGENCY_PROFIT_SETTING = 'orderAgcProfitSetting',
  BID_PRICE_CONSTRAINT = 'bidPriceConstraint',
  FIXED_CPC = 'fix_cpc',
  FIXED_CPM = 'fix_cpm',
  FIXED_CPV = 'fix_cpv',
  FIXED_VCPM = 'fix_vcpm',
  DYNAMIC_CPM = 'dynamic_cpm',
  FIXED_ACPM = 'fix_acpm',
  FIXED_WCPM = 'fix_wcpm',
  OPTIMIZE_CPC_IN_RS = 'optimizeCpcInRS',
  OPTIMIZE_VCPM_IN_RS = 'optimizeVcpmInRS',
  REVENUE_SHARING = 'revenueSharing',
  BUDGET_DOMINATE = 'budgetDominate',
  ROADBLOCK = 'roadblock',
  ENABLE_OPTIMIZED_PRICE = 'enableOptimizedPrice',
  VIDEO_AD_VIEW_OBJECTIVE = 'videoAdViewObjective',
  THIRDPARTY_TRACKING = 'thirdparty_tracking',
  RETARGETING_TRACKER = 'retargeting_tracker',
  FIX_CPC = 'fix_cpc',
  FIX_VCPM = 'fix_vcpm',
  ADMIN_BID_PRICE_SETTING = 'admin_bid_price_setting'
}

export enum CREATIVES {
  IMAGE = 'option_1',
  HTML5 = 'option_2',
  NATIVE = 'option_3',
  VIDEO = 'option_4',
  DYNAMIC = 'option_5',
  THIRD_PARTY = 'option_8',
  COMBO = 'option_10',
  EDIMAX = 'option_11',
  ONE_FOR_ALL_DISPLAY = 'option_13',
  ONE_FOR_ALL_VIDEO = 'option_16',
  CTV = 'option_23',
  CUSTOM_RECTANGLE = 'option_24',
  CUSTOM_BOTTOM = 'option_25',
  PIC_SHORT = 'option_26',
  PIC_LONG = 'option_27',
  SANDBOX_OUTDOOR = 'option_35',
  FRIDGE_LONG = 'option_37',
  PIC_EXTENDED = 'option_38',
  FRIDGE_EXTENDED = 'option_39',
  PIC_BROAD = 'option_40',
  OUTDOOR_LINE_MESSAGE = 'option_41',
  FRIDGE_BROAD = 'option_42',
  LINE_MESSAGE = 'option_43',
  HWACOM_SHORT = 'option_44',
  HWACOM_LONG = 'option_45',
  HWACOM_EXTENDED = 'option_46',
  HWACOM_BROAD = 'option_47',
  CUSTOMIZE_ADLOGO = 'customizeAdLogo'
}

enum COMPANY {
  AGENCY_PROFIT = 'agencyProfit',
  AGENCY_REBATE = 'rebate',
  AGENCY_INCENTIVE = 'incentive',
  AGENCY_PROVIDE_REPORT_TO_WORKFLOW = 'provideReportToWorkflow',
  SINGLE_ORDER_BUDGET_CONSTRAINT = 'singleOrderBudgetConstraint',
  PRODUCT_GROUP = 'productGroup',
  USE_AGENCY_PROFIT_ON_REBATE_REPORT = 'useAgencyProfitOnRebateReport',
  SHOW_OVERSPEND_ON_REBATE_REPORT = 'showOutComeOnRebateReport',
  AGENCY_CREDIT_LIMIT = 'creditLimit',
  AGENCY_ALLOW_ORDER_SETTLEMENT = 'allowOrderSettlement',
  AGENCY_ALLOW_ORDER_AUTO_SETTLEMENT = 'allowOrderAutoSettlement',
  MODIFY_ORDER_BUDGET_AFTER_SETTLEMENT = 'modifyOrderBudgetAfterSettlement',
  USE_FIXED_EXCHANGE_RATE = 'fixedExchangeRate',
  ADVERTISER_VIEW_SPENT_IN_REPORT = 'advertiserViewSpentInReport',
  LOOKALIKE_AUDIENCE_CREATION = 'lookalikeAudienceCreation',
  STORED_VALUE = 'storedValue',
  AGENCY_SEGMENT = 'agencySegment',
  ADV_ADMIN_INFO_RESTRICTION = 'advAdminInfoRestriction',
  DIRECTLY_APPROVE_CREATIVE = 'directlyApproveCreative'
}

enum LIMITATION {
  LIMITATION_COUNTRY = 'country',
  LIMITATION_SPACETYPE = 'spaceType',
  LIMITATION_DEVICE = 'device',
  LIMITATION_TARGET_AUDIENCE = 'target_audience',
  LIMITATION_HABITS = 'habits',
  LIMITATION_ADEXCHANGE = 'adexchange',
  LIMITATION_ASIAMAX_SPACE = 'asiamax_space',
  LIMITATION_DOMAIN = 'domain',
  LIMITATION_SPACE_CATEGORY = 'space_category',
  LIMITATION_TENMAX_AUDIENCE = 'tenmax_audience',
  LIMITATION_CITY = 'city',
  LIMITATION_GENDER = 'gender',
  LIMITATION_AGE = 'age',
  LIMITATION_CARRIER = 'carrier',
  ENABLE_PMP_DEAL = 'enablePMPDeal',
  KEYWORD = 'keyword',
  LIMITATION_CONTENT_LANGUAGE = 'content_language',
  LIMITATION_CONTENT_CATEGORY = 'content_category'
}

enum CREATIVE_STUDIO {
  DCS_TEMPLATES = 'templates'
}

enum CONVERSION_TRACKING {
  CONV_TRACKING_LIST = 'TrackingList',
  MARKETPLACE_MAIN = 'main',
  MARKETPLACE_DATA = 'data'
}

enum REPORT {
  REPORT_VIDEO = 'video',
  REPORT_VIEWABLE_CTR = 'viewableCtr',
  REPORT_CAMPAIGN_DASHBOARD = 'campaignDashboard',
  REPORT_YAHOOAD = 'yahooAd',
  REPORT_CLOSINGREPORT = 'closingReport',
  REPORT_RESTRICT_FINALREPORT = 'restrictFinalReport',
  REPORT_ORDER_CUSTOM = 'orderCustom',
  REPORT_OUTDOOR_FINALREPORT = 'cantDownloadOutdoorFinalReport',
  REPORT_DELIVERY_BRIEF = 'deliveryBriefReport'
}

enum MONITOR {
  MONITOR_CAMPAIGN_UNDERBIDFLOOR = 'campaignUnderBidFloor',
  MONITOR_CAMPAIGN_BEHIND_PROGRESS = 'campaignBehindProgress'
}

enum PRODUCT {
  E_COMMERCE = 'index',
  EC_PROGRAMMATIC_STRATEGY = 'programmaticStrategy',
  EC_CONVERSION = 'conversion'
}

export const AddonDependency = {
  [COMPANY.USE_AGENCY_PROFIT_ON_REBATE_REPORT]: [
    COMPANY.AGENCY_PROVIDE_REPORT_TO_WORKFLOW
  ],
  [COMPANY.SHOW_OVERSPEND_ON_REBATE_REPORT]: [
    COMPANY.AGENCY_PROVIDE_REPORT_TO_WORKFLOW
  ],
  [COMPANY.AGENCY_REBATE]: [COMPANY.AGENCY_PROVIDE_REPORT_TO_WORKFLOW],
  [COMPANY.AGENCY_ALLOW_ORDER_AUTO_SETTLEMENT]: [
    COMPANY.AGENCY_ALLOW_ORDER_SETTLEMENT
  ],
  [COMPANY.MODIFY_ORDER_BUDGET_AFTER_SETTLEMENT]: [
    COMPANY.AGENCY_ALLOW_ORDER_SETTLEMENT
  ],
  // [CAMPAIGN.ORDER_AGENCY_PROFIT_SETTING]: [COMPANY.AGENCY_PROFIT],
  [LIMITATION.LIMITATION_CITY]: [LIMITATION.LIMITATION_COUNTRY]
};

/** channel-scoped addon sub-key（不含 category 前綴），如 `channel_0_fix_cpc`。 */
export type ChannelScopedKey = `channel_${number}_${string}`;

/** per-channel campaign flag 的 scoped composite key（見 `perChannelCampaignKey`）。 */
export type PerChannelCampaignKey = `campaign_${ChannelScopedKey}`;

export type AddonFeatureType =
  | CHANNEL
  | ADSORDER
  | CAMPAIGN
  | CREATIVES
  | COMPANY
  | LIMITATION
  | CREATIVE_STUDIO
  | CONVERSION_TRACKING
  | REPORT
  | MONITOR
  | PRODUCT
  | PerChannelCampaignKey
  | `${number}`;

export const ADDONFEATURE = {
  CHANNEL,
  ADSORDER,
  CAMPAIGN,
  CREATIVES,
  COMPANY,
  LIMITATION,
  CREATIVE_STUDIO,
  CONVERSION_TRACKING,
  REPORT,
  MONITOR,
  PRODUCT
};

/**
 * Per-channel campaign addon flag 的查詢 key（用於 `isFeatureEnable`）。
 *
 * 設計背景：`addonFeatures.campaign` 自 RKB-2466 起改為混合結構：
 *   - root-level keys（如 `bid_weight_setting`、`dynamic_cpm`）→ 仍以原本 key 直接
 *     傳入 `isFeatureEnable`，語意為「該 agency 是否已開通此計價模式（agency-level
 *     provisioning）」。
 *   - per-channel keys（巢狀於 `campaign.channel[channelGroupId][addonKey]`）→
 *     透過本 helper 構建 composite key，語意為「該 channel 是否啟用此計價模式」。
 *
 * `DefaultAddonFeatureManager.convertAgencyAddonFeatures` 會把 per-channel 子樹
 * 攤平成這個 composite 格式並放進 `modelAddonFeatures` 陣列，因此 `isFeatureEnable`
 * 不需要新增第二個參數或新方法即可同時支援兩種讀取方式。
 *
 * 範例：
 *   isFeatureEnable(perChannelCampaignKey(0, ADDONFEATURE.CAMPAIGN.FIXED_CPC))
 *   // 等價於檢查 addonFeatures.campaign.channel[0].fix_cpc === true
 */
/**
 * channel-scoped addon sub-key builder（不含 category 前綴），如
 * `channel_0_fix_cpc`。存進 `addonFeatures.<category>[<key>]` 的扁平結構，
 * 同時供 `perChannelCampaignKey`（core）與 agency 表單（component）組裝
 * per-channel key 使用。
 */
export const channelScopedKey = (
  channelGroupId: number,
  addonKey: string
): ChannelScopedKey => `channel_${channelGroupId}_${addonKey}`;

export const perChannelCampaignKey = (
  channelGroupId: number,
  addonKey: string
): PerChannelCampaignKey =>
  `campaign_${channelScopedKey(channelGroupId, addonKey)}`;
